
/* 
 * this will load widget data for a signle widget, then render it on screen
 */

async function launchWidget (data) {
    console.log('AppClient.launchWidget(): ', data );
    const env = this.env;
    if (data?.apikey || data?.pageParams?.apiKey) {

        let apikey = data?.apikey;
        if (!apikey) {
            apikey = data?.pageParams?.apiKey;
        }
        this.settings.apikey = apikey;

        if (!env.appStore.widgetSettings.apikey) {
            env.appStore.widgetSettings.apikey = apikey;
        }
        
    }

    const widget = await env.widgetStore.getWidget(data.widgetId);
    if (widget.id) {
        this.notifyClientPage({
            action: 'widgetLoaded',
            data: {
                widget,
                params: data.pageParams,
            },
        });
        this.showWidget({
            widget,
            ...data,
        });
    }
}

export default launchWidget;